import React from 'react'
import { readTheme, readDirection } from '../utils/themeHelpers'
// import { ZHDict } from '@/locales';

export const AppContext = React.createContext({
  direction: readDirection(),
  theme: readTheme(), // [themeName,direction]
  onChangeDirection: null,
  onChangeTheme: null,
  onChangeLanguage: null,
  onChangeFontSize: null,
  messages: null,
  language: 'zh',
  localePath: '',
  styleLoaded: false,
})

export default AppContext
